import { render, staticRenderFns } from "./AppExpandIcon.vue?vue&type=template&id=6b569185"
import script from "./AppExpandIcon.vue?vue&type=script&lang=js"
export * from "./AppExpandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports